
import React, { useEffect, useState } from "react";
import { Input, Select, DatePicker, TimePicker, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import Axios from "../../../services/AxiosInterceptor";

const { Option } = Select;

const AddDemo = () => {
  const [locationandRec, setLocationandRec] = useState([]);
  const [locationIndex, setLocationIndex] = useState(0);
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    classMode: "",
    sessionType: "",
    seatAvailability: "",
    benefits: ["", "", "", "", ""],
    description: "",
  });


  const [locationSpecificData, setLocationSpecificData] = useState({});
  const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const getLocationandresource = async () => {
  try {
    const response = await Axios.get("api/location-list");

    const result = response.data; // <-- Axios JSON

    if (result) {
      setLocationandRec(result);
    }
  } catch (error) {
    console.error("Error loading location & resource:", error);
  }
};

  useEffect(() => {
    getLocationandresource();
  }, []);

  const handleCommonField = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLocationField = (key, value) => {
    const currentLocation = locationandRec[locationIndex]?.location;
    setLocationSpecificData((prev) => ({
      ...prev,
      [currentLocation]: {
        ...prev[currentLocation],
        [key]: value,
      },
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
    }
  };

  const handleBenefitsChange = (index, value) => {
    const updatedBenefits = [...formData.benefits];
    updatedBenefits[index] = value;
    setFormData((prev) => ({
      ...prev,
      benefits: updatedBenefits,
    }));
  };

  const handleSubmitSessions = async () => {
  const currentLocation = locationandRec[locationIndex]?.location;
  const sessionData = locationSpecificData[currentLocation] || {};

  try {
    const response = await Axios.post(
      "api/session-creation",
      {
        startDate: sessionData.startDate,
        endDate: sessionData.endDate,
        sessionDuration: sessionData.sessionDuration,
        startTime: sessionData.startTime,
        endTime: sessionData.endTime,
        offDays: sessionData.offDays,
        bufferTime: sessionData.bufferTime,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = response.data; // <-- replaces await response.json()

    if (result?.success) {
      setLocationSpecificData((prev) => ({
        ...prev,
        [currentLocation]: {
          ...prev[currentLocation],
          sessions: result.sessionData.sessions,
        },
      }));
    }
  } catch (error) {
    console.error("❌ Error:", error);
  }
};

  const handlelocaationIndex = (index) => {
    setLocationIndex(index);
  };

  const handlecheck = (resource) => {
    const currentLocation = locationandRec[locationIndex].location;
    setLocationSpecificData((prev) => {
      const locationData = prev[currentLocation] || {};
      const resources = locationData.resources || [];
      let updatedResources;

      if (resources.includes(resource)) {
        updatedResources = resources.filter((res) => res !== resource);
      } else {
        updatedResources = [...resources, resource];
      }

      return {
        ...prev,
        [currentLocation]: {
          ...locationData,
          resources: updatedResources,
        },
      };
    });
  };

const handleSubmit1 = async () => {
  try {
    const locations = Object.keys(locationSpecificData).map((loc) => ({
      name: loc,
      resources: locationSpecificData[loc].resources || [],
      sessions: locationSpecificData[loc].sessions || [],
    }));

    const submitData = {
      title: formData.title,
      classMode: formData.classMode,
      sessionType: formData.sessionType,
      seatAvailability: parseInt(formData.seatAvailability),
      benefits: formData.benefits.filter((b) => b.trim() !== ""),
      description: formData.description,
      locations,
    };

    const formDataToSend = new FormData();
    formDataToSend.append("services[0][title]", submitData.title);
    formDataToSend.append("services[0][classMode]", submitData.classMode);
    formDataToSend.append("services[0][sessionType]", submitData.sessionType);
    formDataToSend.append("services[0][seatAvailability]", submitData.seatAvailability);

    submitData.benefits.forEach((benefit, index) => {
      formDataToSend.append(`services[0][benefits][${index}]`, benefit);
    });

    formDataToSend.append("services[0][description]", submitData.description);

    if (imageFile) {
      formDataToSend.append("image", imageFile);
    }

    submitData.locations.forEach((loc, index) => {
      formDataToSend.append(`services[0][locations][${index}][name]`, loc.name);

      loc.resources.forEach((resource, rIndex) => {
        formDataToSend.append(`services[0][locations][${index}][resources][${rIndex}]`, resource);
      });

      loc.sessions.forEach((session, sessionIndex) => {
        formDataToSend.append(
          `services[0][locations][${index}][sessions][${sessionIndex}][date]`,
          session.date
        );

        session.timeSlots.forEach((timeSlot, timeIndex) => {
          formDataToSend.append(
            `services[0][locations][${index}][sessions][${sessionIndex}][timeSlots][${timeIndex}][time]`,
            timeSlot
          );
        });
      });
    });

    // ------------------ ONLY CHANGE ↓ ------------------
    const response = await Axios.post("/api/add_demo",formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // ---------------------------------------------------

    const result = response.data;

    if (result?.success) {
      alert("Demo added successfully with all locations!");
      setFormData({
        title: "",
        classMode: "",
        sessionType: "",
        seatAvailability: "",
        benefits: ["", "", "", "", ""],
        description: "",
      });
      setLocationSpecificData({});
      setPreview(null);
      setImageFile(null);
      setLocationIndex(0);
    } else {
      console.error("Server response:", result);
      alert("Failed to add demo: " + (result.message || "Unknown error"));
    }
  } catch (error) {
    console.error("Error:", error);
    alert("An error occurred while submitting the form.");
  }
};

  const currentLocation = locationandRec[locationIndex]?.location;
  const currentLocationData = locationSpecificData[currentLocation] || {};

  return (
    <div className="container p-6 mx-auto">
      <h3 className="mb-4 text-2xl font-semibold">Add New Demo</h3>

      <div className="flex flex-col items-center p-4 mb-6 border border-orange-400 rounded-lg md:flex-row">
        <div className="w-full mb-4 md:w-1/2 md:mb-0">
          <Input type="file" onChange={handleImageChange} className="w-full" accept="image/*" />
        </div>
        <div className="flex flex-col items-center w-full md:w-1/2">
          <p>Preview:</p>
          {preview && <img src={preview} alt="Preview" className="h-auto max-w-full mt-2 border rounded-lg" />}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 p-6 border border-orange-400 rounded-lg md:grid-cols-3">
        <div>
          <label className="block font-medium">Title</label>
          <Input
            placeholder="Demo Title"
            value={formData.title}
            onChange={(e) => handleCommonField("title", e.target.value)}
          />
        </div>
        <div>
          <label className="block font-medium">Choose Class Mode</label>
          <Select
            value={formData.classMode || "Choose Class Mode"}
            onChange={(value) => handleCommonField("classMode", value)}
            className="w-full"
          >
            <Option value="Online">Online</Option>
            <Option value="Offline">Offline</Option>
          </Select>
        </div>
        <div>
          <label className="block font-medium">Select Session Type</label>
          <Select
            value={formData.sessionType || "Select Session Type"}
            onChange={(value) => handleCommonField("sessionType", value)}
            className="w-full"
          >
            <Option value="Group Session">Group Session</Option>
            <Option value="Personal Session">Personal Session</Option>
          </Select>
        </div>
        <div>
          <label className="block font-medium">Enter Seat Availability</label>
          <Input
            type="number"
            placeholder="Seats Available"
            value={formData.seatAvailability}
            onChange={(e) => handleCommonField("seatAvailability", e.target.value)}
            className="w-full"
          />
        </div>
      </div>

      <div className="p-6 mt-2 border border-orange-400 rounded-lg">
        <label className="block font-medium">Benefits</label>
        <br />
        <div style={{ display: "flex" }}>
          {formData.benefits.map((benefit, index) => (
            <Input
              key={index}
              placeholder={`Benefit ${index + 1}`}
              value={benefit}
              onChange={(e) => handleBenefitsChange(index, e.target.value)}
            />
          ))}
        </div>
        <div>
          <label className="block font-medium">Demo Description</label>
          <TextArea
            value={formData.description}
            onChange={(e) => handleCommonField("description", e.target.value)}
          />
        </div>
      </div>

      <div className="gap-2 p-6 mt-2 border border-orange-400 rounded-lg">
        <label className="block font-medium">Location & Resource</label>
        {locationandRec ? (
          locationandRec.map((item, index) => (
            <Button
              style={{ background: locationIndex === index ? "orange" : "" }}
              onClick={() => handlelocaationIndex(index)}
              key={index}
            >
              {item.location}
            </Button>
          ))
        ) : (
          <p>Loading...</p>
        )}

        <div>
          {locationandRec && locationandRec.length > 0 ? (
            locationandRec[locationIndex].resource.map((res, index) => (
              <label key={index}>
                <input
                  type="checkbox"
                  checked={(currentLocationData.resources || []).includes(res)}
                  onChange={() => handlecheck(res)}
                />
                {res}
              </label>
            ))
          ) : (
            <p className="text-gray-500">No resources available</p>
          )}
        </div>
      </div>

      <label className="block font-medium">Sessions for {currentLocation}</label>
      <div className="gap-2 p-6 mt-2 border border-orange-400 rounded-lg d-flex">
        <div>
          <label className="block font-medium">Start Date</label>
          <DatePicker
            className="w-full"
            placeholder="Start Date"
            value={currentLocationData.startDate ? moment(currentLocationData.startDate) : null}
            onChange={(date, dateString) => handleLocationField("startDate", dateString)}
          />
        </div>
        <div>
          <label className="block font-medium">End Date</label>
          <DatePicker
            className="w-full"
            placeholder="End Date"
            value={currentLocationData.endDate ? moment(currentLocationData.endDate) : null}
            onChange={(date, dateString) => handleLocationField("endDate", dateString)}
          />
        </div>
        <div>
          <label className="block font-medium">Session Duration</label>
          <Input
            className="w-full"
            placeholder="Duration (in hours)"
            value={currentLocationData.sessionDuration}
            onChange={(e) => handleLocationField("sessionDuration", e.target.value)}
          />
        </div>
        <div>
          <label className="block font-medium">Buffer Time</label>
          <Input
            className="w-full"
            placeholder="Buffer Time (in minutes)"
            value={currentLocationData.bufferTime}
            onChange={(e) => handleLocationField("bufferTime", e.target.value)}
          />
        </div>
        <div>
          <label className="block font-medium">Start Time</label>
          <TimePicker
            className="w-full"
            placeholder="Start Time"
            format="HH:mm"
            value={currentLocationData.startTime ? moment(currentLocationData.startTime, "HH:mm") : null}
            onChange={(time, timeString) => handleLocationField("startTime", timeString)}
          />
        </div>
        <div>
          <label className="block font-medium">End Time</label>
          <TimePicker
            className="w-full"
            placeholder="End Time"
            format="HH:mm"
            value={currentLocationData.endTime ? moment(currentLocationData.endTime, "HH:mm") : null}
            onChange={(time, timeString) => handleLocationField("endTime", timeString)}
          />
        </div>
        <div style={{ width: "200px" }}>
          <label className="block font-medium">Off Days</label>
          <Select
            mode="multiple"
            placeholder="Select Off Days"
            value={currentLocationData.offDays || []}
            onChange={(value) => handleLocationField("offDays", value)}
            className="w-full"
          >
            {weekDays.map((day) => (
              <Option key={day} value={day}>
                {day}
              </Option>
            ))}
          </Select>
        </div>
        <Button style={{ marginTop: "20px", background: "orange" }} onClick={handleSubmitSessions}>
          Save Sessions
        </Button>
      </div>

      <div className="p-6 mt-2 border border-orange-400 rounded-lg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <label>Session Dates</label>
                </div>
                <div className="col-6">
                  <label>Times</label>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <hr />
                  {currentLocationData.sessions?.map((session, sessionIndex) =>
                    session.timeSlots.map((timeSlot, timeIndex) => (
                      <div className="row" key={`${sessionIndex}-${timeIndex}`}>
                        <div className="col-6">
                          {timeIndex === 0 && <button>{session?.date}</button>}
                        </div>
                        <div className="col-6">
                          <button>{timeSlot}</button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap col-span-1 gap-4 md:col-span-3">
        <div className="w-full md:w-1/4">
          <Button className="block font-medium" onClick={handleSubmit1}>
            Save Demo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddDemo;
